import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=17b01332&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=ts"
export * from "./Policy.vue?vue&type=script&lang=ts"
import style0 from "./Policy.vue?vue&type=style&index=0&id=17b01332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b01332",
  null
  
)

export default component.exports